import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";

const LoadingSpinner = () => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    fetch("/Scene-Playful.json")
      .then((res) => res.json())
      .then((data) => setAnimationData(data))
      .catch(() => setAnimationData(null));
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(255,255,255,0.92)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
        {animationData ? (
          <Lottie
            animationData={animationData}
            loop
            autoplay
            style={{ width: 400, height: 400 }}
          />
        ) : (
          /* Fallback spinner while JSON loads */
          <div
            style={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              border: "5px solid #f0f0f0",
              borderTopColor: "var(--ap-gold, #d0a177)",
              animation: "spin 0.8s linear infinite",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;

